import { useNavigate } from 'react-router-dom';
import { LockOutlined } from '@mui/icons-material';
import {
  TableBody,
  CircularProgress,
  Grid,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  ButtonBase,
} from '@mui/material';
import { RecordingStatusRow } from './types';

interface Props {
  loading: boolean;
  recordingStatusRows: RecordingStatusRow[];
}

const RecordingStatusContent = ({ loading, recordingStatusRows }: Props) => {
  const navigate = useNavigate();
  if (loading)
    return (
      <Grid container item justifyContent='center' style={{ padding: '1rem' }}>
        <CircularProgress />
      </Grid>
    );

  if (recordingStatusRows.length === 0)
    return (
      <Typography variant='subtitle2' style={{ padding: '1rem' }}>
        No actively recording snapshots.
      </Typography>
    );

  const handleRowClicked = (
    analyzerId: number | undefined,
    snapshotId: number
  ) => {
    navigate(
      `/snapshots/?analyzerId=${analyzerId}&snapshotId=${snapshotId}&recordingMode=true`
    );
  };

  return (
    <TableContainer>
      <Table size='small'>
        <TableHead>
          <TableRow>
            <TableCell>Snapshot</TableCell>
            <TableCell>Recording Mode</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {recordingStatusRows?.map((row) => (
            <TableRow
              hover
              sx={{ '&:last-child td': { border: 0 }, cursor: 'pointer' }}
              key={row.id}
              onClick={() => handleRowClicked(row.analyzerId, row.id)}
            >
              <TableCell>
                <ButtonBase>
                  <Grid item container alignItems='center'>
                    <Typography variant='body2'>{row.name}</Typography>
                    {row.locked && (
                      <LockOutlined sx={{ ml: '.2rem' }} fontSize='small' />
                    )}
                  </Grid>
                </ButtonBase>
              </TableCell>
              <TableCell>
                <ButtonBase>
                  <Typography variant='body2'>{row.recordingStatus}</Typography>
                </ButtonBase>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default RecordingStatusContent;
